import { localeFor, type Language } from "./language.ts";

/**
 * Locale-aware replacement for `value.toFixed(digits)` — Spanish renders a
 * decimal COMMA (`1.234,56`), not the period `toFixed` always hardcodes.
 * `minimumFractionDigits`/`maximumFractionDigits` both set to `digits`
 * preserve `toFixed`'s fixed digit count (no trimming trailing zeros).
 */
export function formatNumber(value: number, language: Language, digits: number): string {
  return new Intl.NumberFormat(localeFor(language), {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);
}
